/**
 * The safe reasons a teacher application can be refused (TCH-04-FR-08).
 *
 * Mirrors the backend enum in
 * `backend/src/verticals/iqmax/teacher-onboarding/domain/review-reasons.ts`,
 * which owns the copy the candidate actually reads. The labels here are for
 * the reviewer choosing a code, not for the candidate — the candidate never
 * sees this file's text, only what the API returns.
 */
export const REVIEW_REASON_CODES = [
  'DOCUMENT_UNREADABLE',
  'DOCUMENT_EXPIRED',
  'DOCUMENT_INCOMPLETE',
  'DOCUMENT_UNSUPPORTED',
  'NAME_MISMATCH',
  'APPLICATION_INCOMPLETE',
  'OTHER',
] as const;

export type ReviewReasonCode = (typeof REVIEW_REASON_CODES)[number];

/** What the reviewer picks from. */
export const REVIEW_REASON_LABELS: Record<ReviewReasonCode, string> = {
  DOCUMENT_UNREADABLE: 'No se puede leer el documento',
  DOCUMENT_EXPIRED: 'Documento vencido',
  DOCUMENT_INCOMPLETE: 'Documento incompleto',
  DOCUMENT_UNSUPPORTED: 'Tipo de documento no aceptado',
  NAME_MISMATCH: 'El nombre no coincide con la solicitud',
  APPLICATION_INCOMPLETE: 'Falta información en la solicitud',
  OTHER: 'Otro (no se explica al candidato)',
};
